import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    roles: [],
    permissions: [],
    error: null,
};

const rolePermissionSlice = createSlice({
    name: "rolePermissions",
    initialState,
    reducers: {
        rolePermissionStart: (state) => {
            state.loading = true;
            state.error = null;
        },

        rolePermissionSuccess: (state, action) => {
            state.loading = false;
            state.roles = action.payload.roles;
            state.permissions = action.payload.permissions;
        },

        rolePermissionFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },

        updateRolePermissions: (state, action) => {
            const { roleId, permissionIds } = action.payload;

            state.roles = state.roles.map((role) => {
                if (role.id !== roleId) return role;

                return {
                    ...role,
                    permissions: state.permissions.filter((p) =>
                        permissionIds.includes(p.id)
                    ),
                };
            });
        },
    },
});

export const {
    rolePermissionStart,
    rolePermissionSuccess,
    rolePermissionFailure,
    updateRolePermissions,
} = rolePermissionSlice.actions;

export default rolePermissionSlice.reducer;